/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import { Button, Dropdown } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

// custom imports
import DropdownActions from './DropdownActions';
import {
  redirectURLLink,
  emailValidation,
  convertPDFURLFromAPI,
  convertHtmlToEmailPlainText,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { safeWindowOpen } from '../../../../SharedModules/CommonUtilities/safeWindowOpen';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import { getRebatePgmDetail } from '../../../Maintain/RebateProgram/SearchRebate/store/actions';
import { getDefaultAuditValues } from '../../../Maintain/RebateProgram/store/actions';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';

// custom imports
import { tableGridHight350 } from '../../../../SharedModules/CommonConstants/commonConstants';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { tablehead } from './tablehead';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import viewHistory from '../../../../assets/images/Icon-Component-History.svg';
import {
  getTemplateDetail,
  saveLetterTemplateDetailList,
  setExtraStateFromOther,
  getTemplateTypeList,
} from '../../../Maintain/LetterTemplate/store/actions';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import {
  selectedType,
  dispatchCellClick,
} from '../../../Maintain/Contract/store/actions';
import {
  dispatchErrorMsg,
  dispatchGCLData,
  saveGCLData,
  getGCLData,
  dispatchGCLDetailPageData,
  getFromMailIDCreateTemplate,
  setGCLExtraState,
  sendGCLDataAPI,
  dispatchSaveGCLData,
  dispatchSendGCLData,
  dispatchGCLDetailList,
  getPrintPreview,
  getShowPrintPreview,
  dispatchPrintPreview,
  dispatchGetToMailID,
  dispatchGetFromMailID,
  updateToMailIDCreateTemplate,
  updateFromMailIDCreateTemplate,
} from '../store/actions';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { updateFreeFromTextCreateTemplate } from '../../CreateLetter/store/action';

const Collectionletterdetail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getGclAllData = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.gclDetailPageData
  );
  const getGclSearchData = useSelector(
    (state) =>
      state?.sharedState?.GeneratecdReducer?.gclDetailPageData?.serachData
  );
  const getGclDetailData = useSelector(
    (state) =>
      state?.sharedState?.GeneratecdReducer?.gclDetailPageData?.detailData
  );
  const getCGLListVO = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.gclDetailPageList
  );
  const extraState = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.extraState
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const rebateProgramDetailData = useSelector(
    (state) => state?.sharedState?.SearchRebateReducer?.pgm_res
  );
  const defaultSystemAudit = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.def_sys_aud
  );
  const getSelectionList = useSelector(
    (state) => state.sharedState.GeneratecdReducer.selection_list
  );
  const getPriorQtrValue = useSelector(
    (state) => state.sharedState.GeneratecdReducer.getPriorQtrData
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const fetchLetterTemplateDetail = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.fetchLetterTemplateDetail
  );

  const templateTypeList = useSelector(
    (state) => state.sharedState.LetterTemplateReducer.templateType
  );
  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.getErrorsFromGCL
  );
  const getAllGclData = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.getGCLData
  );
  const getSaveGclData = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.saveGclData
  );
  const sendGclData = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.sendGclData
  );
  const pdfPreview = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.pdfPreview
  );
  const fromMailId = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.fromMailId
  );
  const toMailId = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.toMailId
  );

  const gridRef = React.useRef();
  const RedColor='#a81f00';
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const [callRedirectRebateProgram, setCallRedirectRebateProgram] =
    useState(false);
  const [gridApi, setGridApi] = useState(gridRef);
  const [paramsStore, setParamsStore] = React.useState();
  const [commonPopup, setCommonPopup] = useState(false);
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [customizeLetterPopup, setCustomizeLetterPopup] = useState(false);
  const [invoiceNum, setInvoiceNum] = useState(null);
  const [freeFromTextValue, setFreeFromTextValue] = useState('');
  const [columnApi, setColumnApi] = useState(null);
  const [gridParams, setGridParams] = React.useState(null);
  const [successMessages, setSuccessMessage] = useState([]);
  const [keyValue, setKeyValue] = useState([]);
  const [modalView, setModalView] = useState(false);
  const [modalMsg, setModalMsg] = useState(null);
  const [viewEmail, setViewEmail] = useState(false);
  const [emailInputValue, setEmailInputValue] = useState({
    to: [],
    from: '',
  });
  const [viewEmailInput, setViewEmailInput] = useState({
    to: false,
    from: false,
  });
  const [includeNoEmailContact, setIncludeNoEmailContact] = useState(false);
  const [toEmailIdValid, setToEmailValid] = useState(false);
  const [fromEmailIdValid, setFromEmailValid] = useState(false);

  const onGridReady = React.useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setGridParams(params);
    if (tableData && tableData?.length > 0) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            tableData.findIndex((x) => {
              return x.invNum === node.data.invNum && x.value;
            }) && node.setSelected(true)
      );
    }
  }, []);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // handling by default row selection for ROSI

  // This run when error msg change and save in redux
  const setErrorStateChange = (val) => {
    dispatch(
      dispatchErrorMsg({
        ...getErrorMsg,
        ...val,
      })
    );
  };

  // This run when state value changed and save in redux
  const setStateChange = (val) => {
    dispatch(
      setGCLExtraState({
        ...extraState,
        ...val,
      })
    );
  };

  // This run when error msg change and save in redux
  const setUpdateDetail = (val) => {
    dispatch(
      dispatchGCLDetailPageData({
        ...getGclAllData,
        ...val,
      })
    );
  };

  // full screen view action
  const handleFullScreenViewForFirstGrid = () => {
    const newData = {
      ...getGclSearchData,
    };
    newData.fullScreenView = !getGclSearchData?.fullScreenView;
    setUpdateDetail({
      serachData: newData,
    });
  };

  // -------handle View History Popup-----------------------------------
  const handleViewHistory = () => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.letterId;
    setShowViewHistory(true);
    const temp = {
      LETTER_ID: selectedRow,
    };
    setKeyValue(temp);
  };

  // This Run when isRefresh is true
  React.useEffect(() => {
    if (
      localStore &&
      localStore.length > 0 &&
      localStore.filter(
        (x) => x.navTo === '/Collectionletterdetail' && x.isRefresh
      ).length > 0
    ) {
      handleScrollToEvent();
      dispatch(dispatchSaveGCLData([]));
      setErrorStateChange({ detailScreenErrors: [] });
      dispatch(
        getFromMailIDCreateTemplate({
          userId: logInUser,
        })
      );
      const newObj = localStore.map((item) => {
        if (item.navTo === '/Collectionletterdetail' && item.isRefresh) {
          item.isRefresh = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [localStore]);

  const callRefreshList = () => {
    if (getGclSearchData && !_.isEmpty(getGclSearchData)) {
      const payload = {
        qtr: getGclSearchData.quarter,
        rpc: getGclSearchData.rebateProgramCd,
        uraChecked: getGclSearchData.uraChecked,
        daysSinceInvoiceDistributed: parseInt(
          getGclSearchData.daysInvoiceDistributed,
          [0, 10000]
        ),
        paymentStatus: parseInt(getGclSearchData.paymentStatus, [0, 10000]),
      };

      if (getGclSearchData.paymentStatus === '3') {
        payload.percentPaid = getGclSearchData.percentPaid;
      }
      if (getGclSearchData.paymentStatus === '4') {
        payload.amountOwed = getGclSearchData.amountOwed;
      }
      if (!_.isEmpty(getGclSearchData.selectedTemplate)) {
        payload.templateId = getGclSearchData.selectedTemplate.templateId;
        payload.templateVersion =
          getGclSearchData.selectedTemplate.templateVersion;
        dispatch(getGCLData(payload));
      }
    }
  };

  // after save done and media Cd is Print then get and open print pdf
  React.useEffect(() => {
    if (extraState?.saveAction && extraState?.actionType === 'OpenPrint') {
      if (pdfPreview && !_.isEmpty(pdfPreview)) {
        setLoading(false);
        if (pdfPreview?.status === '001' && pdfPreview?.message === 'SUCESS') {
          if (pdfPreview.data && pdfPreview.data !== '') {
            const purl = convertPDFURLFromAPI(pdfPreview.data);
            if (extraState?.actionType === 'OpenPrint') {
              setStateChange({
                saveAction: false,
                actionType: '',
              });
              dispatch(dispatchPrintPreview([]));
              safeWindowOpen(purl);
            }
            callRefreshList();
            setSuccessMessage([constantMessageData.JOB_COMPLETE]);
          } else {
            const err = {
              field: 'saveFail',
              errorType: 'saveFail',
              message: constantMessageData.FAIL_PROCESSING_REQUEST,
            };
            setStateChange({
              saveAction: false,
              actionType: '',
            });
            setErrorStateChange({ detailScreenErrors: [err] });
          }
        } else {
          const err = {
            field: 'saveFail',
            errorType: 'saveFail',
            message: constantMessageData.FAIL_PROCESSING_REQUEST,
          };
          setStateChange({
            saveAction: false,
            actionType: '',
          });
          setErrorStateChange({ detailScreenErrors: [err] });
        }
      }
    }
  }, [
    extraState?.saveAction,
    extraState?.actionType,
    pdfPreview,
    getGclSearchData,
  ]);

  // after save done and media Cd is Both then get and open print pdf
  React.useEffect(() => {
    if (extraState?.saveAction && extraState?.actionType === 'OpenPrintMail') {
      if (pdfPreview && !_.isEmpty(pdfPreview)) {
        setLoading(false);
        if (pdfPreview?.status === '001' && pdfPreview?.message === 'SUCESS') {
          if (pdfPreview.data && pdfPreview.data !== '') {
            const purl = convertPDFURLFromAPI(pdfPreview.data);
            setStateChange({
              saveAction: false,
              actionType: '',
            });
            dispatch(dispatchPrintPreview([]));
            safeWindowOpen(purl);
          }
        }
      }
    }
  }, [extraState?.saveAction, extraState?.actionType, pdfPreview]);

  // set data as filter wise
  const getProperData = (value, data) => {
    let arr = _.map(data, (item, i) => {
      if (item.sentDt === null) {
        item.sendFlag = true;
        item.notNeededFlag = false;
        item.includeAlreadySent = value?.includeAlreadySent;
      }
      return item;
    });
    if (!value?.includeAlreadySent && !_.isEmpty(arr)) {
      arr = _.filter(arr, (l) => !l.sentDt);
    }
 
    if (!value?.includeNoEmailContact && !_.isEmpty(arr)) {
      arr = _.filter(arr, (l) => l.emailAdd && l.emailAdd !== '' && !_.isNil(l.emailAdd));
    }
    return arr;
  };

  // after save done and media Cd is Mail or Both then get and open print pdf
  React.useEffect(() => {
    if (extraState?.saveAction && extraState?.actionType === 'SendMail') {
      if (sendGclData && !_.isEmpty(sendGclData)) {
        if (
          sendGclData?.status === '001' &&
          sendGclData?.message === 'SUCESS'
        ) {
          if (!_.isEmpty(sendGclData?.createLetterSendLetterVO)) {
            const checkMail = _.filter(
              sendGclData?.createLetterSendLetterVO,
              (l) => !l.sentDt || _.isNull(l.sentDt) || l.sentDt === ''
            );
            const getSendedMail = _.filter(
              sendGclData?.createLetterSendLetterVO,
              (l) => l.sentDt && !_.isNull(l.sentDt) && l.sentDt !== ''
            );
            const newData = { ...getGclDetailData };
            // newData.generateCollectionLetterListVO = _.map(
            //   newData?.generateCollectionLetterListVO,
            //   (val) => {
            //     const getSuccList = _.filter(
            //       getSendedMail,
            //       (l) => l.letterId === val.letterId
            //     );
            //     if (!_.isEmpty(getSuccList)) {
            //       val.sentDt = getSuccList[0].sentDt;
            //       val.sendClrId = '11513855';
            //     }
            //     return val;
            //   }
            // );
            // const arr = getProperData(
            //   getGclSearchData,
            //   newData.generateCollectionLetterListVO
            // );
            // // eslint-disable-next-line no-unused-expressions
            // gridParams?.api.refreshCells();
            // setUpdateDetail({
            //   detailData: newData,
            // });
            // dispatch(dispatchGCLDetailList(arr));
            dispatch(dispatchSendGCLData([]));

            if (!_.isEmpty(checkMail)) {
              setLoading(false);
              setStateChange({
                saveAction: false,
                actionType: '',
              });
              let allLetterId = _.map(checkMail, (l, i) => l.letterId);
              allLetterId = _.join(allLetterId, ', ');
              const msg = `Email Send fail for Letter Id ${allLetterId}.`;
              setModalView(true);
              setModalMsg(msg);
            } else {
              if (newData?.mediaCd === 'BOTH') {
                const getSuccList = _.map(getSendedMail, (l) => {
                  const request = {
                    templateId: getGclDetailData.templateId,
                    templateVersion: getGclDetailData.templateVersion,
                    invoiceNumber: l.invoiceNum,
                    userId: logInUser,
                    letterId: l.letterId,
                  };
                  return request;
                });
                setLoading(true);
                dispatch(getShowPrintPreview(getSuccList));
              } else {
                setLoading(false);
              }
              callRefreshList();
              setSuccessMessage([constantMessageData.JOB_COMPLETE]);
              setStateChange({
                saveAction: newData?.mediaCd === 'BOTH',
                actionType: newData?.mediaCd === 'BOTH' ? 'OpenPrintMail' : '',
              });
            }
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
          const err = {
            field: 'saveFail',
            errorType: 'saveFail',
            message: constantMessageData.FAIL_PROCESSING_REQUEST,
          };
          setErrorStateChange({ detailScreenErrors: [err] });
        }
      }
    }
  }, [
    extraState?.saveAction,
    extraState?.actionType,
    sendGclData,
    getGclSearchData,
    getGclDetailData,
  ]);

  // get save success response
React.useEffect(() => {
  if (extraState?.saveAction && extraState?.actionType === 'SaveData') {
    if (getSaveGclData && !_.isEmpty(getSaveGclData)) {
      if (
        getSaveGclData?.status === '001' &&
        getSaveGclData?.message === 'SUCESS'
      ) {
        if (!_.isEmpty(getSaveGclData?.letterHeaderVO)) {
          const newData = { ...getGclDetailData };
            // newData.generateCollectionLetterListVO = _.map(
            //   newData?.generateCollectionLetterListVO,
            //   (val) => {
            //     const getUpList = _.filter(
            //       getSaveGclData?.letterHeaderVO,
            //       (l) => l.recipientId === val.mfgId
            //     );
            //     if (!_.isEmpty(getUpList)) {
            //       _.forEach(getUpList[0], (v, k) => {
            //         val[k] = v;
            //       });
            //       val.sendFlag = true;
            //       if (newData?.mediaCd === 'PRINT') {
            //         val.sendClrId = '11513855';
            //       }
            //     }
            //     return val;
            //   }
            // );
            // const arr = getProperData(
            //   getGclSearchData,
            //   newData.generateCollectionLetterListVO
            // );
            // // eslint-disable-next-line no-unused-expressions
            // gridParams?.api.refreshCells();
            // setUpdateDetail({
            //   detailData: newData,
            // });
            // dispatch(dispatchGCLDetailList(arr));
          dispatch(dispatchSaveGCLData([]));
          if (newData?.mediaCd === 'BOTH' || newData?.mediaCd === 'EMAIL') {
            const filteredData = getSaveGclData?.letterHeaderVO.filter(
              (v) => v.doNotSendInd == 0
            );

            if (filteredData.length) {
              const request = _.map(filteredData, (v) => {
                let msg = null;
                if (v?.printPreviewVO && !_.isEmpty(v?.printPreviewVO)) {
                  msg = `<div>${
                    v?.printPreviewVO?.header ? v?.printPreviewVO?.header : ''
                  }</div> <div>${
                    v?.printPreviewVO?.body ? v?.printPreviewVO?.body : ''
                  }</div> <div>${
                    v?.printPreviewVO?.footer ? v?.printPreviewVO?.footer : ''
                  }</div>`;
                }
                return {
                  letterId: v.letterId,
                  contactTypeCd: getGclSearchData.contactTypeCd,
                  rebateProgramCd: v.rebateProgramCd,
                  mfgId: v.recipientId,
                  templateId: v.templateId,
                  templateVersion: v.templateVersion,
                  userId: logInUser,
                  lobStagingVO: {
                    dest: 'EMAIL',
                    invNum: v.invoiceNum,
                    fileName: `Invoice_${v.invoiceNum}`,
                    fileContent: null,
                    toAddress: v.emailAddr,
                    // toAddress: 'shravan.chaurasiya@conduent.com',
                    fromAddress: fromMailId.fromMailId,
                    subject:
                      v?.printPreviewVO && !_.isEmpty(v?.printPreviewVO)
                        ? v?.printPreviewVO?.emailSubject
                        : null,
                    // message:
                    //   v?.printPreviewVO && !_.isEmpty(v?.printPreviewVO)
                    //     ? htmlToFormattedText(v?.printPreviewVO?.body)
                    //     : null,
                    message: msg ? convertHtmlToEmailPlainText(msg) : null,
                  },
                  corrCommentVO: {
                    corrName: v.corpName,
                    corpName: v.corpName,
                    addrLine1: v.addrLine1,
                    addrLine2: v.addrLine2,
                    addrLine3: v.addrLine3,
                    city: v.city,
                    stateCd: v.stateCd,
                    zip: v.zip,
                    zip4: v.zip4,
                    emailAddr: v.emailAddr,
                    phoneNum: v.phoneNum,
                    phoneExtension: v.phoneExtension,
                    faxNum: v.faxNum,
                  },
                };
              });
              setLoading(true);
              dispatch(sendGCLDataAPI(request));
              setStateChange({
                saveAction: true,
                actionType: 'SendMail',
              });
            }
          } else {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        dispatch(dispatchSaveGCLData([]));
        const err = {
          field: 'saveFail',
          errorType: 'saveFail',
          message: constantMessageData.FAIL_PROCESSING_REQUEST,
        };
        setStateChange({
          saveAction: false,
          actionType: '',
        });
        setErrorStateChange({ detailScreenErrors: [err] });
      }
    }
  }
}, [getSaveGclData, extraState]);

  // get PaymentList
  const setPaymentListOptions = [
    { name: 'No Payment Received', value: '1' },
    { name: 'No Payment Received and Amount Owed >0', value: '2' },
    { name: 'Percent Paid <', value: '3' },
    { name: 'Amount Owed >', value: '4' },
    { name: 'Not Paid in Full', value: '5' },
  ];

  const paymentName = React.useMemo(() => {
    let findindex = setPaymentListOptions.findIndex(
      (item) => item.value === getSelectionList.paymentStatus
    );
    let name = setPaymentListOptions[findindex]?.name;
    return name;
  }, [getSelectionList]);

  // get proper Print media name
  const mediumList = React.useMemo(() => {
    const list = [
      { name: 'Print/Mail Only', id: 'PRINT' },
      { name: 'Email Only', id: 'EMAIL' },
      { name: 'Either (try Email first)', id: 'BOTH' },
    ];
    return list;
  }, []);

const getIndexForPayLoad = () => {
  let arr = [];
  if (!_.isEmpty(getCGLListVO)) {
    const arr2 = getCGLListVO.filter((item) => item.sendFlag === true || item.notNeededFlag == true);
    if (!_.isEmpty(arr2)) {
      arr = _.map(arr2, (prop) => {
        const request = {
          freeFormText: prop.freeFormText,
          rebateProgramCd: getGclSearchData?.rebateProgramCd,
          contactSeqNum: prop.contractSrqNum,
          recipientId: prop.mfgId,
          invoiceNum: prop.invNum,
          sendFlag: prop.sendFlag,
          notNeededFlag: prop.notNeededFlag,
          customizedFlag: false,
        };
          if (prop.letterId) {
            request.letterId = prop.letterId;
          }
        return request;
      });
    }
  }
  return arr;
};

  const setIncludeAlreadySent = (flType, value) => {
    setSuccessMessage([]);
    setErrorStateChange({ detailScreenErrors: [] });
    if (
      !_.isEmpty(getGclDetailData) &&
      !_.isEmpty(getGclDetailData?.generateCollectionLetterListVO)
    ) {
      const newData = {
        ...getGclSearchData,
      };
      newData[flType] = value;
      const arr = getProperData(
        newData,
        getGclDetailData?.generateCollectionLetterListVO
      );
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
      setUpdateDetail({
        serachData: newData,
      });
      dispatch(dispatchGCLDetailList(arr));
    }
  };

  const checkUncheckAction = (flType) => {
    setSuccessMessage([]);
    setErrorStateChange({ detailScreenErrors: [] });
    const sendVal = flType === 'check';

    if (!_.isEmpty(getCGLListVO)) {
      const arr = _.map(getCGLListVO, (item) => {
        item.sendFlag = sendVal;
        item.notNeededFlag = false;
        return item;
      });

      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
      dispatch(dispatchGCLDetailList(arr));
    }
  };

  const tableData = React.useMemo(() => {
    let newData = [];
    if (!_.isEmpty(getCGLListVO)) {
    
      const includeNoEmail = getGclSearchData?.includeNoEmailContact;
      if (includeNoEmail) {
        newData = getCGLListVO;
      } else {
        newData = _.filter(getCGLListVO, (l) => l.emailAdd && l.emailAdd !== '' && !_.isNil(l.emailAdd));
      }
    }
    return newData;
  }, [getCGLListVO]);

  // check mailed list
  const mailCheckList = React.useMemo(() => {
    let payLoad = [];
    let mailCheck = [];
    if (!_.isEmpty(getCGLListVO)) {
      const newData = _.cloneDeep(getCGLListVO);
      payLoad = _.filter(newData, (item) => item.sendFlag === true);
      payLoad = _.unionBy(payLoad, 'contractSrqNum');
      if (!_.isEmpty(payLoad)) {
        mailCheck = _.filter(payLoad, (l) => !l.emailAdd || l.emailAdd === '');
        // mailCheck = payLoad;
      }
    }
    return mailCheck;
  }, [getCGLListVO]);

  // mail save api call here
  const majorSave = () => {
    setSuccessMessage([]);
    setErrorStateChange({ detailScreenErrors: [] });
    const payLoad = getIndexForPayLoad();
    const runPass = true;
    // getGclDetailData?.mediaCd === 'PRINT' ? true : _.isEmpty(mailCheckList);
    if (runPass && !_.isEmpty(payLoad)) {
      const request = {
        actionFlag: 'SaveGCL',
        senderId: logInUser,
      };
      if (
        !_.isEmpty(payLoad) &&
        !_.isEmpty(getGclSearchData) &&
        !_.isEmpty(getGclDetailData)
      ) {
        request.templateTypeCd = !_.isEmpty(getGclSearchData?.selectedTemplate)
          ? getGclSearchData?.selectedTemplate?.templateTypeCd
          : 'COLLECT';
        request.templateId = getGclDetailData.templateId;
        request.templateVersion = getGclDetailData.templateVersion;
        request.gclLetterHeaderVO = payLoad;
        setLoading(true);
        if (getGclDetailData?.mediaCd === 'PRINT') {
          setStateChange({
            saveAction: true,
            actionType: 'OpenPrint',
          });
          dispatch(getPrintPreview(request));
        } else {
          setStateChange({
            saveAction: true,
            actionType: 'SaveData',
          });
          dispatch(saveGCLData(request));
        }
      }
    }
  };

// on save action for check mail
const onSendLetterAction = () => {
  setErrorStateChange({ detailScreenErrors: [] });
  if (getGclDetailData?.mediaCd === 'PRINT') {
    majorSave();
  }
  if (
    getGclDetailData?.mediaCd === 'BOTH' ||
    getGclDetailData?.mediaCd === 'EMAIL'
  ) {
    const toMailIdData = mailCheckList;
    if (
      !_.isEmpty(toMailIdData) ||
      !fromMailId?.fromMailId ||
      fromMailId?.fromMailId === ''
    ) {
      setEmailInputValue({
        to: toMailIdData || [],
        from: fromMailId?.fromMailId || '',
      });
      setViewEmailInput({
        to: !_.isEmpty(toMailIdData),
        from: !fromMailId?.fromMailId || fromMailId?.fromMailId === '',
      });
      setViewEmail(true);
    } else {
      const payLoad = getIndexForPayLoad().filter(
        (item) => item.sendFlag === true && item.notNeededFlag !== true
      );

      // Check if we have a single object, and send the API accordingly
      if (payLoad.length === 1) {
        if (payLoad[0].sendFlag === true) {
          majorSave();
        }
      } else {
        majorSave();
      }
    }
  }
};

  const mailAction = (flType, row, val) => {
    const newData = emailInputValue;
    let value = val?.target?.value || val;
    if (flType === 'to') {
      value = newData.to;
      if (!_.isEmpty(row)) {
        value = _.map(newData.to, (l) => {
          if (l.contractSrqNum === row.contractSrqNum) {
            l.emailAdd = val;
            l.valid = false;
          }
          return l;
        });
      }
    }
    setEmailInputValue({
      ...emailInputValue,
      [flType]: value,
    });
  };

  const onBlurToMailValue = (row, val) => {
    const newData = emailInputValue;
    let value = newData.to;
    if (!_.isEmpty(row)) {
      value = _.map(value, (l) => {
        if (l.contractSrqNum === row.contractSrqNum) {
          l.valid = val;
        }
        return l;
      });
    }
    const checkValid = _.filter(value, (l) => l.valid);
    setToEmailValid(!_.isEmpty(checkValid));
    setEmailInputValue({
      ...emailInputValue,
      to: value,
    });
  };

  // after Update mail Id getting response
  React.useEffect(() => {
    let errorView = false;
    let msg = '';
    let errorPass = false;
    const emailStateVal = emailInputValue;
    const emailStateView = viewEmailInput;
    if (toMailId && !_.isEmpty(toMailId)) {
      if (toMailId.updateAction) {
        if (!_.isEmpty(toMailId.data)) {
          const checkAllUpdate = _.filter(toMailId.data, (l) => !l.mailUpdate);
          if (_.isEmpty(checkAllUpdate)) {
            const orgData = _.cloneDeep(getGclDetailData);
            if (
              !_.isEmpty(orgData) &&
              !_.isEmpty(orgData?.generateCollectionLetterListVO)
            ) {
              orgData.generateCollectionLetterListVO = _.map(
                orgData?.generateCollectionLetterListVO,
                (val) => {
                  const getVal = _.filter(
                    toMailId.data,
                    (l) => l.invNum === val.invNum
                  );
                  if (!_.isEmpty(getVal)) {
                    val.emailAdd = getVal[0].emailAdd;
                  }
                  return val;
                }
              );
              setUpdateDetail({ detailData: orgData });
            }
            if (!_.isEmpty(getCGLListVO)) {
              let orglist = _.cloneDeep(getCGLListVO);
              orglist = _.map(orglist, (val) => {
                const getVal = _.filter(
                  toMailId.data,
                  (l) => l.invNum === val.invNum
                );
                if (!_.isEmpty(getVal)) {
                  val.emailAdd = getVal[0].emailAdd;
                }
                return val;
              });
              dispatch(dispatchGCLDetailList(orglist));
              // eslint-disable-next-line no-unused-expressions
              gridParams?.api.refreshCells();
            }
            emailStateView.to = false;
            emailStateVal.to = [];
            msg = 'All To mail Id update successfull.';
            errorView = true;
          } else {
            let allLetterId = _.map(checkAllUpdate, 'contractSrqNum');
            allLetterId = _.join(allLetterId, ', ');
            msg = `Fail to update To mail Id for contact is ${allLetterId}.`;
            errorView = true;
          }
        } else {
          let allLetterId = _.map(emailInputValue.to, 'contractSrqNum');
          allLetterId = _.join(allLetterId, ', ');
          msg = `Fail to update To mail Id for contact is ${allLetterId}.`;
          errorView = true;
        }
        errorPass = true;
      }
    }
    if (fromMailId && !_.isEmpty(fromMailId)) {
      if (fromMailId.isUpdate) {
        if (!fromMailId.fromMailId || fromMailId.fromMailId === '') {
          msg += `\n Fail to update from mail id for user ${logInUser}.`;
          errorView = true;
        } else {
          emailStateVal.from = '';
          emailStateView.from = false;
          msg += '\n From mail Id update successfull.';
          errorView = true;
        }
        errorPass = true;
        setViewEmail(emailStateView.to || emailStateView.from);
      }
    }
    if (!_.isEmpty(fromMailId) || !_.isEmpty(toMailId)) {
      if (toMailId.updateAction || fromMailId.isUpdate) {
        setViewEmail(emailStateView.to || emailStateView.from);
      }
    }
    if (errorPass) {
      dispatch(dispatchGetToMailID({ updateAction: false, data: [] }));
      dispatch(
        dispatchGetFromMailID({
          isUpdate: false,
          fromMailId: fromMailId.fromMailId,
        })
      );
      setEmailInputValue(emailStateVal);
      setViewEmailInput(emailStateView);
      setModalView(errorView);
      setModalMsg(msg);
    }
  }, [toMailId, fromMailId]);

  // update email after click ok in email modal and save
  const onOkUpdateToMailId = () => {
    if (viewEmailInput.to && !toEmailIdValid) {
      if (emailInputValue.to && !_.isEmpty(emailInputValue.to)) {
        dispatch(updateToMailIDCreateTemplate(emailInputValue.to, logInUser));
      }
    }
    if (viewEmailInput.from && !fromEmailIdValid) {
      if (emailInputValue.from && emailInputValue.from !== '') {
        dispatch(
          updateFromMailIDCreateTemplate({
            mailId: emailInputValue.from,
            userId: logInUser,
          })
        );
      }
    }
    majorSave();
  };

  // get all data on detail page GCL Data
  React.useEffect(() => {
    const localErr = [];
    if (!_.isEmpty(getAllGclData)) {
      let showError = false;

      const newState = {
        ..._.cloneDeep(getGclSearchData),
        // includeAlreadySent: false,
        includeNoEmailContact:
          getGclSearchData && typeof getGclSearchData.includeNoEmailContact !== 'undefined'
            ? getGclSearchData.includeNoEmailContact
            : false,
        fullScreenView: false,
      };
      if (
        getAllGclData?.message === 'SUCESS' &&
        getAllGclData?.status === '001'
      ) {
        if (!_.isEmpty(getAllGclData?.gclVO)) {
          const newGCLData = _.cloneDeep(getAllGclData?.gclVO);
          if (!_.isEmpty(newGCLData?.generateCollectionLetterListVO)) {
            let cglListVO = _.map(
              newGCLData.generateCollectionLetterListVO,
              (item) => {
                if ('sendFlag' in item) {
                  return item;
                }
                // item.sendFlag = true;
                const hasSentDate = !!item.sentDt;
                item.sendFlag = !hasSentDate;
                item.notNeededFlag = false;
                item.freeFormText = item.freeFormText ? item.freeFormText : '';
                item.letterId = item.letterId ? item.letterId : null;
                return item;
              }
            );
            cglListVO = getProperData(newState, cglListVO);
            // newGCLData.generateCollectionLetterListVO = cglListVO;
            const newData = {
              serachData: newState,
              detailData: newGCLData,
            };
            dispatch(dispatchGCLDetailList(cglListVO));
            dispatch(dispatchGCLData([]));
            setUpdateDetail(newData);

            // eslint-disable-next-line no-unused-expressions
            gridParams?.api.refreshCells();
          } else {
            showError = true;
          }
        } else {
          showError = true;
        }
      } else {
        showError = true;
      }
      if (showError) {
        const newDetailData = _.cloneDeep(getGclDetailData);
        newDetailData.generateCollectionLetterListVO = [];
        const newData = {
          serachData: newState,
          detailData: newDetailData,
        };
        dispatch(dispatchGCLDetailList([]));
        dispatch(dispatchGCLData([]));
        setUpdateDetail(newData);

        // eslint-disable-next-line no-unused-expressions
        gridParams?.api.refreshCells();
        localErr.push({
          field: 'search',
          errorType: 'noResults',
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
        });

        setErrorStateChange({ detailScreenErrors: [...new Set(localErr)] });
      }
    }
  }, [getAllGclData]);

  // redirect Go to Customize Letter Popup
  const handleGoToCustomizeLetter = (row) => {
    setSuccessMessage([]);
    setErrorStateChange({ detailScreenErrors: [] });
    setInvoiceNum(row?.mfgId);

    setFreeFromTextValue(row?.freeFormText);
    setCustomizeLetterPopup(true);
  };

  // update after enter content in free from text and click ok for save
  const updateFreeFromText = () => {
    if (
      freeFromTextValue &&
      freeFromTextValue !== '' &&
      !_.isNull(freeFromTextValue)
    ) {
      const data = getCGLListVO.find((item)=>item.mfgId === invoiceNum)
      const arr = getCGLListVO.map((item, i) => {
        if (item.mfgId === invoiceNum) {
          item.freeFormText = freeFromTextValue;
        }
        return item;
      });

      dispatch(dispatchGCLDetailList(arr));
      setCustomizeLetterPopup(false);
      setInvoiceNum('');
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
      const request = {
        letterId: data.letterId,
        freeFormText: freeFromTextValue,
        userId: logInUser,
      };

      setFreeFromTextValue('');
      dispatch(updateFreeFromTextCreateTemplate(request));
    }
  };

  // handing Invoice Detail page redirect
  const handleViewDetailsForInvoiceDetail = async (data) => {
    setErrorStateChange({ detailScreenErrors: [] });
    await dispatch(
      getInvoiceDetailsByInvoiceNum({
        invoiceNum: data?.invNum,
      })
    );
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };

  // go to particular Contract action button handler function
  const handleGoToContract = (row, detail) => {
    setErrorStateChange({ detailScreenErrors: [] });
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('C'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'contractId';
    searchContractState.selectedRowData = row?.contractSrqNum;
    searchContractState.selectedContractId = row?.contractSrqNum;
    searchContractState.rebateProgramCode = detail?.rebateProgramCd;
    redirectURLLink('/createContract', 'Maintain Contract', history, dispatch);
  };

  // go to particular manufacturer action button handler function
  const handleGoToManufacturer = async (row) => {
    setErrorStateChange({ detailScreenErrors: [] });
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    const data = await dispatch(fetchAllManufacturerDetail({mfgId:row?.mfgId}));
    dispatch(
      setSelectManufacturerData({
        mfgId: row?.mfgId,
        mfgName: row?.mfgName,
        mfgTypeCd: (data?.manufacturerDetailsList?.mfgVO?.mfgTypeCd||'C'),
        updateManufacturer: true,
      })
    );
    redirectURLLink(
      '/manufacturer-detail',
      'Maintain Manufacturer',
      history,
      dispatch
    );
  };

  React.useEffect(() => {
    if (rebateProgramDetailData && rebateProgramDetailData.status === '001') {
      if (callRedirectRebateProgram) {
        if (!defaultSystemAudit) dispatch(getDefaultAuditValues());
        localStorage.setItem('viewpgmdetails', 'true');
        redirectURLLink(
          '/maintainRebate',
          'Maintain Rebate Program',
          history,
          dispatch
        );
        setCallRedirectRebateProgram(false);
      }
    }
  }, [rebateProgramDetailData]);

  
  // go to particular Rebate Program action button handler function
  const handleGoToRebateProgram = () => {
    setErrorStateChange({ detailScreenErrors: [] });
    dispatch(
      getRebatePgmDetail({
        planType: getSelectionList?.planTypeCd,
        rebateProg: getSelectionList?.rebateProgramCd,
      })
    );
    setCallRedirectRebateProgram(true);
  };

  // check detail reponse and redirect on Letter Template detail page
  React.useEffect(() => {
    if (!_.isEmpty(fetchLetterTemplateDetail)) {
      const optionList = !_.isEmpty(templateTypeList)
        ? _.map(templateTypeList, (val) => val.codeValueID.codeValue)
        : [];
      dispatch(setExtraStateFromOther({ templeType: optionList }));
      dispatch(saveLetterTemplateDetailList(fetchLetterTemplateDetail));
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/letterTemplateDetail',
        value: 'Letter Detail',
        isFormDirty: false,
        isFormError: false,
        isFormSave: false,
        isRefresh: true,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      history.push({ pathname: '/letterTemplateDetail' });
    }
  }, [fetchLetterTemplateDetail, templateTypeList]);

  const handleGoToLetterTemplate = () => {
    setErrorStateChange({ detailScreenErrors: [] });
    if (!_.isEmpty(getGclDetailData)) {
      dispatch(
        getTemplateTypeList({
          codeDomainList: ['PLAN_TYPE_CD', 'TEMPLATE_TYPE_CD'],
        })
      );
      dispatch(
        getTemplateDetail({
          actionType: 'Update',
          data: {
            templateId: getGclDetailData.templateId,
            templateVersion: getGclDetailData.templateVersion,
          },
        })
      );
    }
  };

  const btnDisabled = React.useMemo(() => {
    const payLoad = getIndexForPayLoad();
    return _.isEmpty(payLoad);
  }, [getCGLListVO]);

  const checkBtnActive = React.useMemo(() => {
    let btn = true;
    if (!_.isEmpty(getCGLListVO)) {
      const arr = _.filter(getCGLListVO, (item) => item.sendFlag === true);
      btn = !_.isEmpty(arr) ? arr.length === getCGLListVO.length : false;
    }
    return btn;
  }, [getCGLListVO]);

  const unCheckBtnActive = React.useMemo(() => {
    let btn = true;
    if (!_.isEmpty(getCGLListVO)) {
      const arr = _.filter(getCGLListVO, (item) => item.sendFlag === false);
      btn = !_.isEmpty(arr) ? arr.length === getCGLListVO.length : false;
    }
    return btn;
  }, [getCGLListVO]);

  const onAgGridCellAction = (row) => {
    setSuccessMessage([]);
    setErrorStateChange({ detailScreenErrors: [] });
    const newList = row?.node?.parent?.allLeafChildren
      ? _.map(row?.node?.parent?.allLeafChildren, (val) => val.data)
      : [];
    if (!_.isEmpty(newList)) {
      dispatch(dispatchGCLDetailList(newList));
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api.refreshCells();
    }
  };

  React.useEffect(() => {
    const checkAndSetAttributes = () => {
      const hiddenTextarea = document.querySelector(
        'textarea[aria-hidden="true"]'
      );
      if (hiddenTextarea) {
        hiddenTextarea.setAttribute('id', 'hiddenTextArea');
        // Optionally, you can add an aria-labelledby to link it with a label
        // hiddenTextarea.setAttribute('aria-labelledby', 'hiddenLabel');
        return true;
      }
      return false;
    };
    // Try to set the attributes every 100ms, for up to 1 second
    const intervalId = setInterval(() => {
      if (checkAndSetAttributes()) {
        clearInterval(intervalId); // Stop checking once the element is found
      }
    }, 100);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className='tabs-container'
      data-testid='generateCollectionLetterDetail'
    >
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1='Tasks'
        parent2='Generate Collection Letter Detail'
      />
      <DisplaySuccessMessages successMessages={successMessages} />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            getErrorMsg?.detailScreenErrors?.length > 0
              ? _.map(getErrorMsg.detailScreenErrors, (l) => l.message)
              : []
          ),
        ]}
      />

      {!getGclSearchData?.fullScreenView && (
        <div className='mui-custom-form no-margin custom-check'>
          <div className='mt-2'>
            <fieldset
              data-testid='radio-box-component'
              className='custom-fieldset'
            >
              <div className='row'>
                <div className='col-12 col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='rebate-id-textField'
                    className='mt-2'
                    labelName='Rebate Program'
                    disabled
                    select={false}
                    inputProps={{ maxLength: 38 }}
                    placeholder='Rebate Program'
                    defaultValue={
                      getGclSearchData && getGclSearchData?.rebateProgramCd
                    }
                  />

                  <SelectBoxWithoutBoxComponent
                    data-testid='medium-id-textField'
                    className='mt-2'
                    labelName='Template Name'
                    disabled
                    select={false}
                    placeholder='Template'
                    defaultValue={
                      getGclSearchData &&
                      getGclSearchData?.selectedTemplate &&
                      getGclSearchData?.selectedTemplate.name
                    }
                  />

                  <SelectBoxWithoutBoxComponent
                    data-testid='quarter-id-textField'
                    className='mt-2'
                    labelName='Quarter'
                    disabled
                    select={false}
                    placeholder='Quarter'
                    defaultValue={getGclSearchData && getGclSearchData?.quarter}
                  />
                </div>

                <div className='col-12 col-sm-6 col-md-4'>
                  <SelectBoxWithoutBoxComponent
                    data-testid='medium-id-textField'
                    className='mt-2'
                    labelName='Medium'
                    disabled
                    select
                    selectedOne={false}
                    placeholder='Please Select One'
                    optionList={mediumList || []}
                    defaultValue={getGclDetailData && getGclDetailData?.mediaCd}
                  />
                  <SelectBoxWithoutBoxComponent
                    data-testid='medium-id-textField'
                    className='mt-2 mb-3'
                    className2='input-text-single-line'
                    labelName='Days Since Invoice Distributed >'
                    disabled
                    select={false}
                    selectedOne={false}
                    defaultValue={
                      getGclSearchData &&
                      getGclSearchData?.daysInvoiceDistributed
                    }
                    helperText='Calendar Days'
                    // isError="Calendar Days"
                  />
                  <FormControlLabel
                    className='ml-0 mt-4'
                    data-testid='include-cleared-audits-checkBox'
                    control={<Checkbox color='primary' className='mr-2' />}
                    label='Include Already Sent'
                    value={
                      getGclSearchData && getGclSearchData.includeAlreadySent
                    }
                    checked={
                      getGclSearchData && getGclSearchData.includeAlreadySent
                    }
                    onChange={(e) =>
                      setIncludeAlreadySent(
                        'includeAlreadySent',
                        e.target.checked
                      )
                    }
                  />
                  <FormControlLabel
                    className='ml-0 mt-4'
                    data-testid='include-no-email-contact-checkBox'
                    control={
                      <Checkbox
                        color='primary'
                        className='mr-2'
                        checked={
                          getGclSearchData &&
                          typeof getGclSearchData.includeNoEmailContact !== 'undefined'
                            ? getGclSearchData.includeNoEmailContact
                            : includeNoEmailContact
                        }
                        onChange={(e) => {
                          setSuccessMessage([]);
                          setErrorStateChange({ detailScreenErrors: [] });
                          if (
                            !_.isEmpty(getGclDetailData) &&
                            !_.isEmpty(getGclDetailData?.generateCollectionLetterListVO)
                          ) {
                            const newData = {
                              ...getGclSearchData,
                            };
                            newData.includeNoEmailContact = e.target.checked;
                            const arr = getProperData(
                              newData,
                              getGclDetailData?.generateCollectionLetterListVO
                            );
                            // eslint-disable-next-line no-unused-expressions
                            gridParams?.api.refreshCells();
                            setUpdateDetail({
                              serachData: newData,
                            });
                            dispatch(dispatchGCLDetailList(arr));
                          }
                          setIncludeNoEmailContact(e.target.checked);
                        }}
                      />
                    }
                    label='Include No Email Contact'
                  />
                </div>

                <div className='col-12 col-sm-6 col-md-4 pt-4'>
                  <div className='col-12 mt-3 mb-4'>
                    Payment Status :{paymentName}
                    {getSelectionList?.percentPaid ||
                      getSelectionList?.amountOwed}
                  </div>

                  <div className='col-12 pl-4 mt-4 mb-3 d-flex'>
                    <div
                      className='mr-1'
                      style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'pink',
                      }}
                    />
                    <div> = Already Sent</div>
                  </div>

                  <div className='col-12 pl-4 mt-4 mb-3 d-flex'>
                    <div
                      className='mr-1'
                      style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: 'yellow',
                      }}
                    />
                    <div> = Email Not Available</div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      )}

      {!getGclSearchData?.fullScreenView && (
        <div className='mb-2 mt-3'>
          <div className='welcometxt'>
            <div className='btn-wrapper'>
              <Button
                disabled={checkBtnActive}
                className='btn btn-success btn-save btn-primary'
                data-testid='provider-review-detail-history1'
                onClick={() => checkUncheckAction('check')}
              >
                check All
              </Button>

              <Button
                disabled={unCheckBtnActive}
                className='btn btn-success btn-save btn-primary'
                onClick={() => checkUncheckAction('unCheck')}
                data-testid='provider-review-detail-save'
              >
                unCheck All
              </Button>

              <Button
                disabled={btnDisabled}
                className='btn-success same-font-family'
                onClick={onSendLetterAction}
                data-testid='provider-review-detail-cancel'
              >
                <SVGComponent iconName='Icon-run-now' /> Run Now
              </Button>
            </div>
          </div>
        </div>
      )}

      <div className='row'>
        <div className='col-12'>
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'>
            <TableGrid
              ref={gridRef}
              gridCall={onGridReady}
              gridHeight={
                getGclSearchData?.fullScreenView ? '70vh' : tableGridHight350
              }
              rowData={tableData || []}
              columnDefs={tablehead}
              fullScreenView={getGclSearchData?.fullScreenView}
              handleFullScreenViewClick={handleFullScreenViewForFirstGrid}
              //handleViewHistory={handleViewHistory}
              applyFilter={false}
              isScrollOn
              defaultColWidth={110}
              exportFile
              helpMessage=''
              hideColumnsInPdf={['action']}
              data-testid='onCheckGrid'
              fileName='Generate Collection Letter'
              singleClickEdit
              suppressCellFocus
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              onSelect={(e) => {
                const { data } = e;
                if (data && !_.isEmpty(data)) {
                  if (
                    data?.letterId &&
                    data?.letterId !== '' &&
                    !_.isNull(data?.letterId)
                  ) {
                    setState(data?.letterId);
                  } else {
                    setState(null);
                  }
                }
              }}
              // onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
              onCellFocused={onCellFocused}
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  return (
                    <>
                      <DropdownActions
                        cellInfo={cellInfo}
                        getSelectionList={getSelectionList}
                        getGclDetailData={getGclDetailData}
                        handleGoToCustomizeLetter={handleGoToCustomizeLetter}
                        handleViewDetailsForInvoiceDetail={
                          handleViewDetailsForInvoiceDetail
                        }
                        handleGoToContract={handleGoToContract}
                        handleGoToManufacturer={handleGoToManufacturer}
                        handleGoToRebateProgram={handleGoToRebateProgram}
                        handleGoToLetterTemplate={handleGoToLetterTemplate}
                      />
                      {/* <Dropdown className='icon-dropdown-container'>
                        <Dropdown.Toggle
                          className='icon-dropdown export_wrap'
                          aria-label='export'
                        >
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='action-tooltip'>Actions</Tooltip>
                            }
                          >
                            <SVGComponent iconName='Icon-export1' />
                          </OverlayTrigger>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className='export_dropdown'>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleGoToCustomizeLetter(cellInfo?.data)
                            }
                            disabled={!getGclDetailData?.mergeFieldFlag}
                          >
                            {' '}
                            Customize Letter{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() => {
                              handleViewDetailsForInvoiceDetail(cellInfo.data);
                            }}
                          >
                            Go to Invoice{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleGoToContract(
                                cellInfo?.data,
                                getSelectionList
                              )
                            }
                          >
                            Go to Contract{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleGoToManufacturer(cellInfo?.data)
                            }
                          >
                            Go to Manufacturer{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleGoToRebateProgram(
                                cellInfo?.data,
                                getSelectionList
                              )
                            }
                          >
                            Go to Rebate Program{' '}
                          </Dropdown.Item>
                          <Dropdown.Item
                            role='button'
                            onClick={() =>
                              handleGoToLetterTemplate(
                                cellInfo?.data,
                                getSelectionList
                              )
                            }
                          >
                            Go to Letter Template{' '}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </>
                  );
                },
                MfgNameCellRender: (cellInfo) => {
                  const { mfgName } = cellInfo.data;
                  if (mfgName && mfgName.length > 25) {
                    return (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='labeler-tooltip'>{mfgName}</Tooltip>
                        }
                      >
                        <div>{`${mfgName.substring(0, 25)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{mfgName}</div>;
                },
                MailCellRender: (cellInfo) => {
                  const { emailAdd } = cellInfo.data;
                  if (emailAdd && emailAdd.length > 21) {
                    return (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='labeler-tooltip'>{emailAdd}</Tooltip>
                        }
                      >
                        <div>{`${emailAdd.substring(0, 21)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{emailAdd}</div>;
                },
                CheckBoxCellRender1: (cellInfo) => {
                   return (
                    <>
                      <div className='tbl-checkbox frr-checkbox-no-label'>
                        <FormControlLabel
                          data-testid='checkBox'
                          label='checkbox'
                          control={
                            <Checkbox
                              color='primary'
                              checked={cellInfo.value}
                              onChange={(e) => {
                                cellInfo.node.setDataValue(
                                  cellInfo.column.colId,
                                  e.target.checked
                                );
                                cellInfo.node.setDataValue('notNeededFlag', false);
                                onAgGridCellAction(cellInfo);
                              }}
                            />
                          }
                          value={cellInfo.value}
                        />
                      </div>
                    </>
                  );
                },
                CheckBoxCellRender2: (cellInfo) => {
                  return (
                    <>
                      <div className='tbl-checkbox frr-checkbox-no-label'>
                        <FormControlLabel
                          data-testid='checkBox'
                          label='checkbox'
                          control={<Checkbox color='primary' />}
                          onClick={(e) => {
                            cellInfo.node.setDataValue(
                              cellInfo.column.colId,
                              e.target.checked
                            );
                            cellInfo.node.setDataValue('sendFlag', false);
                            onAgGridCellAction(cellInfo);
                          }}
                          checked={cellInfo.value}
                          value={cellInfo.value}
                        />
                      </div>
                    </>
                  );
                },
                CheckBoxCellRender3: (cellInfo) => {
                  return (
                    <>
                      <div className='tbl-checkbox frr-checkbox-no-label'>
                        <FormControlLabel
                          data-testid='checkBox'
                          label='checkbox'
                          control={<Checkbox color='primary' />}
                          onClick={() => {
                            const checkedVal =
                              parseInt(cellInfo.value, [0, 1]) === 1 ? 0 : 1;
                            cellInfo.node.setDataValue(
                              cellInfo.column.colId,
                              checkedVal
                            );
                          }}
                          disabled
                          checked={parseInt(cellInfo.value, [0, 1]) === 1}
                          value={parseInt(cellInfo.value, [0, 1]) === 1}
                        />
                      </div>
                    </>
                  );
                },
                percentPaidCell: (cellInfo) => {
                  let isNegativeVal = false;
                  if (
                    cellInfo?.data?.amountOwed &&
                    cellInfo?.data?.amountOwed !== 0 &&
                    cellInfo?.data?.amountOwed < 0
                  ) {
                    isNegativeVal = !(
                      parseFloat(cellInfo?.data?.percentPaid) >= 0
                    );
                  }
                  let val = cellInfo?.data?.percentPaid;
                  if (val && val !== 0) {
                    val = parseFloat(val).toFixed(6);
                  }
                  // return <div>{val} %</div>;

                  return (
                    <>
                      {isNegativeVal ? (
                        <div style={{ color: RedColor }}>{`(${val
                          ?.toString()
                          ?.replace('-', '')
                          .trim()} %)`}</div>
                      ) : (
                        <div>{val} %</div>
                      )}
                    </>
                  );
                },
                invoiceCorrectionAmtCellRender1: (cellInfo) => {
                  let isNegativeVal = false;
                  if (
                    cellInfo?.data?.amountOwed &&
                    cellInfo?.data?.amountOwed !== 0 &&
                    cellInfo?.data?.amountOwed < 0
                  ) {
                    isNegativeVal = !(
                      parseFloat(cellInfo?.data?.amountOwed) >= 0
                    );
                  }

                  return (
                    <>
                      {isNegativeVal ? (
                        <div
                          style={{ color: RedColor }}
                        >{`($ ${cellInfo?.data?.amountOwed
                          ?.toString()
                          ?.replace('-', '')
                          .trim()})`}</div>
                      ) : (
                        <div>{`$ ${cellInfo?.data?.amountOwed}`}</div>
                      )}
                    </>
                  );
                },
                invoiceCorrectionAmtCellRender2: (cellInfo) => {
                  let isNegativeVal = false;
                  if (
                    cellInfo?.data?.currRebateAmount &&
                    cellInfo?.data?.currRebateAmount !== 0 &&
                    cellInfo?.data?.currRebateAmount < 0
                  ) {
                    isNegativeVal =
                      parseFloat(cellInfo?.data?.currRebateAmount) >= 0;
                  }

                  return (
                    <>
                      {isNegativeVal ? (
                        <div
                          style={{ color: RedColor }}
                        >{`$ ${cellInfo?.data?.currRebateAmount

                          ?.toString()
                          ?.replace('-', '')
                          .trim()}`}</div>
                      ) : (
                        <div>{`$ ${cellInfo?.data?.currRebateAmount}`}</div>
                      )}
                    </>
                  );
                },
                invoiceCorrectionAmtCellRender3: (cellInfo) => {
                  let isNegativeVal = false;
                  const value = cellInfo?.data?.amountPaidDate;
                  if (value && value !== 0 && value < 0) {
                    isNegativeVal = !(
                      parseFloat(cellInfo?.data?.amountPaidDate) >= 0
                    );
                  }

                  return (
                    <>
                      {isNegativeVal ? (
                        <div
                          style={{ color: RedColor }}
                        >{`$ (${cellInfo?.data?.amountPaidDate
                          ?.toString()
                          ?.replace('-', '')
                          .trim()})`}</div>
                      ) : (
                        <div>{`$ ${cellInfo?.data?.amountPaidDate}`}</div>
                      )}
                    </>
                  );
                },
                invoiceCorrectionAmtCellRender4: (cellInfo) => {
                  let isNegativeVal = false;
                  if (
                    cellInfo?.data?.invAmount &&
                    cellInfo?.data?.invAmount !== 0 &&
                    cellInfo?.data?.invAmount < 0
                  ) {
                    isNegativeVal = parseFloat(cellInfo?.data?.invAmount) >= 0;
                  }

                  return (
                    <>
                      {isNegativeVal ? (
                        <div
                          style={{ color: RedColor }}
                        >{`$ ${cellInfo?.data?.invAmount

                          ?.toString()
                          ?.replace('-', '')
                          .trim()}`}</div>
                      ) : (
                        <div>{`$ ${cellInfo?.data?.invAmount}`}</div>
                      )}
                    </>
                  );
                },
              }}
            />
          </div>
        </div>
      </div>

      {getGclDetailData?.mergeFieldFlag && (
        <div className='frr-rem-dialog-container-pt'>
          <CommonModal
            open={customizeLetterPopup}
            viewAction
            viewHeader
            okTitle='Ok'
            onOk={updateFreeFromText}
            className='dialog-420'
            onClose={() => {
              setFreeFromTextValue('');
              setInvoiceNum('');
              setCustomizeLetterPopup(false);
            }}
            closeTitle='Cancel'
            modalTitle={`Customize Letter - ${invoiceNum}`}
            childrenComponent={
              <>
                <label className='hide-elm' htmlFor='hiddenTextArea'>
                  Comments
                </label>
                {/* <legend className="same-font-family mx-0 frr-legend-font d-flex">
                <span>Comments </span>
              </legend> */}
                <TextField
                  id='outlined-multiline-static'
                  label='Comments'
                  multiline
                  rows={5}
                  className='custom-textarea frr-display-hidden-label'
                  onChange={(e) => setFreeFromTextValue(e.target.value)}
                  defaultValue={freeFromTextValue}
                  InputLabelProps={{
                    shrink: false,
                  }}
                />
              </>
            }
          />
        </div>
      )}

      {viewEmail && (
        <CommonModal
          open={viewEmail}
          viewAction
          viewHeader
          className='dialog-420'
          okTitle='Ok'
          onOk={onOkUpdateToMailId}
          onClose={() => {
            setEmailInputValue({ to: [], from: '' });
            setViewEmailInput({ to: false, from: false });
            setToEmailValid(false);
            setFromEmailValid(false);
            setViewEmail(false);
          }}
          closeTitle='Cancel'
          modalTitle='Request Email Address'
          childrenComponent={
            <div className='mb-2'>
              <p>{constantMessageData.ENTER_VALID_EMAIL_OR_CANCEL}</p>
              {viewEmailInput.to &&
                !_.isEmpty(emailInputValue.to) &&
                _.map(emailInputValue.to, (l) => (
                  <SelectBoxWithoutBoxComponent
                    data-testid='email-id-select-box'
                    className='mt-2'
                    labelName={l.mfgName}
                    placeholder='Email ID'
                    required
                    select={false}
                    inputProps={{ maxLength: 50 }}
                    defaultValue={l.emailAdd}
                    filterAction={(e) => mailAction('to', l, e)}
                    onBlurAction={(e) =>
                      onBlurToMailValue(l, !emailValidation(e))
                    }
                    isError={
                      l?.valid
                        ? l.emailAdd && l.emailAdd !== ''
                          ? constantMessageData.EMAIL_INVALID
                          : constantMessageData.EMAIL_REQUIRED
                        : null
                    }
                  />
                ))}
              {viewEmailInput.from && (
                <SelectBoxWithoutBoxComponent
                  data-testid='email-id-select-box'
                  className='mt-2'
                  labelName={logInUser}
                  placeholder='Email ID'
                  required
                  select={false}
                  inputProps={{ maxLength: 50 }}
                  defaultValue={emailInputValue.from}
                  filterAction={(e) => mailAction('from', null, e)}
                  onBlurAction={(e) => setFromEmailValid(!emailValidation(e))}
                  isError={
                    fromEmailIdValid
                      ? emailInputValue.from && emailInputValue.from !== ''
                        ? constantMessageData.EMAIL_INVALID
                        : constantMessageData.EMAIL_REQUIRED
                      : null
                  }
                />
              )}
            </div>
          }
        />
      )}

      {modalView && modalMsg && (
        <CommonModal
          data-testid='template-detail-errorModal-comp'
          className='dialog-420'
          open={modalView}
          viewHeader
          viewAction
          onOk={() => {
            setModalMsg(null);
            setModalView(false);
          }}
          okTitle='Ok'
          onClose={() => {
            setModalMsg(null);
            setModalView(false);
          }}
          closeTitle={false}
          modalTitle='Warning'
          childrenComponent={<div className='p-3'>{modalMsg}</div>}
        />
      )}

      <div className='row'>
        <div className='col-12 col-sm-12 col-md-9'>
          <FormControlLabel
            className='ml-0'
            data-testid='include-cleared-audits-checkBox1'
            control={<Checkbox color='primary' className='mr-2' />}
            label='If zero URA, use prior qtr URA in calculation'
            disabled
            value={getPriorQtrValue}
            checked={getPriorQtrValue}
          />
        </div>
        <div className='col-12 col-sm-12 col-md-3 text-right'>
          <Button
            className='btn btn-success btn-save btn-primary'
            data-testid='provider-review-detail-history'
            onClick={() => {
              handleViewHistory();
            }}
            //disabled={_.isNull(state)}
          >
            <SVGComponent iconName='Icon-view-history' /> View History
          </Button>
          {showViewHistory && (
            <ViewHistoryComponent
              // setShowViewHistory={(e) => {
              //   setShowViewHistory(e);
              //   setState(null);
              //   setKeyValue([]);
              // }}
              setShowViewHistory={setShowViewHistory}
              tableName='LETTER_HEADER'
              keyValue={keyValue}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Collectionletterdetail;
